import { render, staticRenderFns } from "./beCareful.vue?vue&type=template&id=6ee8f612&scoped=true&"
import script from "./beCareful.vue?vue&type=script&lang=js&"
export * from "./beCareful.vue?vue&type=script&lang=js&"
import style0 from "./beCareful.vue?vue&type=style&index=0&id=6ee8f612&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee8f612",
  null
  
)

export default component.exports